import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector, useStore } from "react-redux";
import { Row, Col, Card, Dropdown,DropdownButton } from "react-bootstrap";
import DealTab from "./DealTab";
import DealTradesTab from "./DealTradesTab";
import DealDetail from "./DealDetail";
import { getDeals,getDealsSearch,getDealTrades, refreshDealStatus,getTradeSearch } from "../../actions/deal-action";
import { DealStatus,TradeListStatuses,TradeListSides,TradeOrders,TradeOrderNames } from "../../Const";
import ContentContainer from "../common/ContentContainer";
import {eligibleResetCompletedPaperTrades, getKeyByValue} from "../../utils/Utils";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ReactStatePagination from "../common/ReactStatePagination";
import { DEALS_ACTIVE_TAB, DEALS_PAGE_CLOSE, GET_DEAL_TRADES, GET_DEALS } from "../../actions/types";
import CustomPagination from "../common/CustomPagination";
import BackButton from "../common/BackButton";
import PaperTradeResetActions from "./PaperTradeResetActions";
import moment from "moment";

const Positions = (props) => {
  const { getDeals,getDealTrades ,refreshDealStatus,getDealsSearch,getTradeSearch} = props;
  const [showDetail, setShowDetail] = useState(-1);
  const [completed, setCompleted] = useState(false);
  const [tradeStatus, setTradeStatus] = useState('');
  const [tradeOrderName, setTradeOrderName] = useState('');
  const [tradeSide, setTradeSide] = useState('');
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const store = useStore();
  const requestIdRef = useRef(0); 

  const tabTitles = [t("open-deals"), t("c-deals"),t("trade-log")];
  const tourClasses = ["open-deals-tour", "completed-deals-tour","trade-logs-tour"];
  const statusArray = ['open','close'] 
  const activeTab = useSelector((state) => state.pagination.dealsActiveTab) || 0;
  const [searchBotName, setSearchBotName] = useState("");
  const pageNumbers = {
    "open":useSelector((state) => state.pagination.dealsOpenPage),
    "close":useSelector((state) => state.pagination.dealsClosePage),
    "trade":1,
  }
  var deals = useSelector((state) => state.deals.deals) || [];
  var trades = useSelector((state) => state.deals.trades) || [];
  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const selectedExchange =
    useSelector((state) => state.settings.selectedExchange) || {};
  const filters = useSelector((state) => state.settings.filters) || [];
  deals = deals.filter((el) => el.exchange_id == selectedExchangeId);
  const completedStatuses = [
    DealStatus.stopLoss,
    DealStatus.takeProfit,
    DealStatus.exited,
    DealStatus.liquidated,
    DealStatus.error,
  ];
  const status = statusArray[activeTab]
  const canResetCompletedPaperTrades = eligibleResetCompletedPaperTrades(selectedExchange);
  const itemsPerPage = 10;
  const pageNum=1;
  const completedDeals = (deals || [])
    .filter((deal) => completedStatuses.includes(deal.status_key))
    .slice()
    .sort((a, b) => moment(b.updated_at).valueOf() - moment(a.updated_at).valueOf());

  const incompletedDeals = (deals || [])
    .filter((deal) => !completedStatuses.includes(deal.status_key))
    .slice()
    .sort((a, b) => moment(b.updated_at).valueOf() - moment(a.updated_at).valueOf());
  const totalDeals = useSelector((state) => state.deals.totalDeals) || 0;
  const totalTrades = useSelector((state) => state.deals.totalTrades) || 0;
  const startItem = useSelector((state) => state.deals.startItem) || 1;
  const tradeStartItem = useSelector((state) => state.deals.tradeStartItem) || 1;
  useEffect(() => {
    //getDeals(selectedExchangeId,itemsPerPage,pageNumbers[status],status,"",searchBotName);
    const currentRequestId = ++requestIdRef.current;
    const resetVersion = store.getState().settings.paperAccountResetVersion;
    if(activeTab!=2){
        getDealsSearch(selectedExchangeId,itemsPerPage,pageNumbers[status],status,"",searchBotName).then((res)=>{
          if(res.data.deals && res.data.deals.data){
            if (currentRequestId === requestIdRef.current && store.getState().settings.paperAccountResetVersion === resetVersion) {
              dispatch({
                  type: GET_DEALS,
                  payload: {
                    deals:res.data.deals.data,
                    totalDeals:res.data.deals.total,
                    startItem:res.data.deals.from
                  },
                });
            }
          }}).catch((error)=>{
            toast.error(error)
          }) 
        }else{
          getTradeSearch(selectedExchangeId,itemsPerPage,pageNumbers['trade'],status,"",searchBotName).then((res)=>{
            if(res.data.trades && res.data.trades.data){
              if (currentRequestId === requestIdRef.current && store.getState().settings.paperAccountResetVersion === resetVersion) {
                dispatch({
                    type: GET_DEAL_TRADES,
                    payload: {
                      trade_list:res.data.trades.data,
                      totalTrades:res.data.trades.total,
                      startItem:res.data.trades.from
                    },
                  });
              }
            }}).catch((error)=>{
              toast.error(error)
            }) 
        }          
    //getDealTrades(selectedExchangeId,itemsPerPage,pageNum,tradeStatus,tradeSide,tradeOrderName);
    return () => { requestIdRef.current += 1; };
  }, [selectedExchangeId,searchBotName]);

  useEffect(() => {
    getDealTrades(selectedExchangeId,itemsPerPage,pageNum,tradeStatus,tradeSide,tradeOrderName);
    //getDealTrades(selectedExchangeId,itemsPerPage,pageNum,tradeStatus,tradeSide,tradeOrderName);
  }, [selectedExchangeId,tradeStatus,tradeSide,tradeOrderName]);
  
  
  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <li className="skltbs-tab-item" key={index}>
					<button className={(index == activeTab ? "skltbs-tab skltbs-active" : "skltbs-tab" )} onClick={() => changeTab(index,index==0?'open':'close')}>{item}</button>
			</li>
    );
  });
  const setActiveTab = (index)=>{
    dispatch({
      type:DEALS_ACTIVE_TAB,
      payload:index
    })
  }
  const changeTab = (index,tab) => {
    setActiveTab(index);
    getDeals(selectedExchangeId,itemsPerPage,pageNum,tab,"",searchBotName)
  };
  const paginationCallback = (pageNum)=>{
    getDeals(selectedExchangeId,itemsPerPage,pageNum,status,"",searchBotName);
  }

  const handleResetComplete = (exchangeId) => {
    if (store.getState().settings.selectedExchangeId !== exchangeId) return;
    requestIdRef.current += 1;
    dispatch({ type: DEALS_PAGE_CLOSE, payload: 1 });
    const currentTab = store.getState().pagination.dealsActiveTab;
    return Promise.all([
      getDeals(exchangeId,itemsPerPage,1,currentTab === 0 ? "open" : "close","",searchBotName),
      getDealTrades(exchangeId,itemsPerPage,1,tradeStatus,tradeSide,tradeOrderName),
    ]);
  };

  const dealTabs = [
    <DealTab
      deals={incompletedDeals}
      t={t}
      completed={false}
      onShowDetail={(id) => {
        setShowDetail(id);
        setCompleted(false);
      }}
      refreshDeal={(id) => {
        return new Promise((resolve,reject)=>{
          refreshDealStatus(id,selectedExchangeId,itemsPerPage,pageNum,status).then((message)=>{
            toast.success(message)
            resolve(message)
          }).catch((error)=>{
            toast.error(error)
            reject(error)
          })
        })
        
      }}
    />,
    <DealTab
      deals={completedDeals}
      t={t}
      completed={true}
      onShowDetail={(id) => {
        setShowDetail(id);
        setCompleted(true);
      }}
    />,
    <DealTradesTab
      t={t}
      trades={trades}
    />
  ];

  const filterItem = filters.map((item, index) => {
    return (
      <Dropdown.Item key={index} eventKey={index}>
        {item.name}
      </Dropdown.Item>
    );
  });

  return (
    <ContentContainer url="trades" title={t("deals")} showChat={true}>
      <div className="dashboard-newuser-area">
      <div className="deshboard-normal-allBots-area">
      <div className="main-right-content">
							<div className="position-tab-area" id="tab-wrap">
								<div className="row">
									<div className="col-12 col-xl-6">
										<div>
											<ul className="skltbs-tab-group">
												{tabHeaders}
											</ul>
										</div>
									</div>
									<div className="col-12 col-xl-6">
										<div className="position-tab-header">
											<div className="deshboard-normal-allBots-header-right positions-toolbar">
                        {canResetCompletedPaperTrades && activeTab == 1 && (
                          <PaperTradeResetActions
                            exchangeId={selectedExchangeId}
                            onResetComplete={handleResetComplete}
                          />
                        )}
												<label>
													<input type="text" placeholder="Search" onChange={(e)=>setSearchBotName(e.target.value)} value={searchBotName}/>
												</label>
											</div>
										</div>
									</div>
								</div>
								<div className="position-table-area">
									<div className="row">
										<div className="col-lg-12">
											<div className="skltbs-panel-group">
											
                          {dealTabs[activeTab]}
												
												
											</div>
                      <div className="bottom-center">
                        {activeTab != 2 ? ( <ReactStatePagination
                          itemsCountPerPage={itemsPerPage}
                          startItem={startItem}
                          selectedTab={status}
                          forPage="deals"
                          totalCount={totalDeals}
                          onChange={paginationCallback}
                          selectedExchangeId={selectedExchangeId}
                          itemsPerPage={itemsPerPage}
                        /> ) : 
                        (<CustomPagination
                          itemsCountPerPage={itemsPerPage}
                          startItem={tradeStartItem}
                          totalCount={totalTrades}
                          onChange={getDealTrades}
                          selectedExchangeId={selectedExchangeId}
                          itemsPerPage={itemsPerPage}
                        />) }
                      </div>
										</div>
									</div>
								</div>
							</div>	
						</div>

      </div>
      </div>

    </ContentContainer>
  );
};

export default connect(null, { getDeals,getDealTrades,refreshDealStatus,getDealsSearch,getTradeSearch })(Positions);
